// Vendors
import React, { useState } from 'react';

// Helpers
import { formatCompletionDate } from '../../../../../components/helpers';

const ProjectCard = ({
  project,
  selectable = false,
  selected = false,
  onClickHandler = () => {}
}) => {
  const { builder } = project;
  const [isSelected, setIsSelected] = useState(selected);

  return (
    <div className="grid__col-xs-12 grid__col-xl-6">
      <div
        className={`card-project card-project--${project.status.toLowerCase()}${
          selectable ? ' card-project--selectable' : ''
        } ${isSelected ? ' card-project--selected' : ''}`}
        onClick={() => {
          if (selectable) {
            setIsSelected(!selected);
            onClickHandler(project.pid);
          }
        }}
      >
        <div className="card-project__address">
          <div className="card-project__street">{project.address}</div>
          <span>
            {project.city}, {project.state} {project.zipcode}
          </span>
          {Object.keys(builder).length !== 0 && (
            <>
              <br />
              <span
                className="u--font-size-sm"
                dangerouslySetInnerHTML={{
                  __html: `${builder.first_name ? builder.first_name : '&nbsp;'}
                  ${builder.last_name ? builder.last_name : '&nbsp;'}
                  ${
                    builder.user_email ? `(${builder.user_email})` : '&nbsp;'
                  }<br />${builder.company ? builder.company : '&nbsp;'}`
                }}
              />
            </>
          )}
        </div>
        <div className="card-project__status">
          <span className="card-project__status-indicator">
            {project.status}
          </span>
          {project.new_messages > 0 && (
            <div className="card-project__messages">
              {project.new_messages} Unread{' '}
            </div>
          )}
        </div>
        <div className="card-project__completion-date">
          <div>
            Complete Date:{' '}
            <span>{formatCompletionDate(project.completion_date)}</span>
          </div>
        </div>
        {project.status === 'Submitted' && project.date_submitted && (
          <div className="card-project__submitted-date">
            <div>
              Date Submitted: <span>{project.date_submitted}</span>
            </div>
          </div>
        )}
        <div className="card-project_qualify-for">
          <div>
            Qualifying for{' '}
            <span className="card-project_qualify-amount">
              {parseInt(project.appliance_total_incentives) > 0
                ? `$${parseInt(
                    project.appliance_total_incentives
                  ).toLocaleString()}`
                : 'TBD'}
            </span>
          </div>
        </div>
        {selectable === false && (
          <div className="card-project__view-details">
            <a
              href={project.permalink}
              className="btn btn--link btn--sm btn--has-arrow module-hover-root"
            >
              <span className="btn__content">
                <span className="btn__text">View/Edit Details</span>
                <span className="btn__arrow arrow"></span>
              </span>
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
